import { render, staticRenderFns } from "./topic-editor.vue?vue&type=template&id=7934a374&scoped=true&"
import script from "./topic-editor.vue?vue&type=script&lang=js&"
export * from "./topic-editor.vue?vue&type=script&lang=js&"
import style0 from "./topic-editor.vue?vue&type=style&index=0&id=7934a374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7934a374",
  null
  
)

export default component.exports